/**
 * 超级管理员登录名（大小写不敏感）：admin / blogadmin。
 * 页面侧权限展示统一走这里，避免各页重复判断。创建于 2026-08-21
 */
export const SUPER_ADMIN_LOGINS = ['admin', 'blogadmin']

/**
 * 判断是否为超级管理员账号。
 * @param {object|string|null|undefined} userOrLoginName - 用户对象（含 uLoginName）或登录名字符串
 * @returns {boolean}
 */
export function isSuperAdmin(userOrLoginName) {
  const raw =
    typeof userOrLoginName === 'string'
      ? userOrLoginName
      : (userOrLoginName && userOrLoginName.uLoginName) || ''
  const name = String(raw).toLowerCase()
  return SUPER_ADMIN_LOGINS.indexOf(name) !== -1
}

/**
 * 从 localStorage 读取当前用户。
 * @returns {object|null}
 */
export function getLocalUser() {
  try {
    const userStr = window.localStorage && window.localStorage.user
    return userStr ? JSON.parse(userStr) : null
  } catch (e) {
    return null
  }
}

/**
 * 当前本地登录用户是否为超级管理员。
 * @returns {boolean}
 */
export function isLocalSuperAdmin() {
  return isSuperAdmin(getLocalUser())
}
